const styles = (theme) => ({
    container: {
        padding: '0.5em',
        width: '100%',
    },
    label: {
        textTransform: 'uppercase',
        fontSize: '.8em',
    },
    serviceList: {
        paddingLeft: '1em',
        marginBottom: '2em',
    },
    serviceItem: {
        listStyle: 'none',
        margin: '.35em 0',
        fontSize: '.95em',
        cursor: 'pointer',
        fontWeight: 500,
        color: theme.palette.primary.main,
        '&:hover': {
            color: '#0066CC',
        },
    },
});

export default styles;
